
var urlToShare = "https://z.ynet.co.il/mshort/generics/Leads/bankhapoalim";

const ga_push = (event, category, action, label) => {
    var data = {
        "event": event,
        "Category": category,
        "Action": action,
        "Label": label
    };
    if (window.dataLayer) {
        window.dataLayer.push(data);
    }
    if (window.location.href.includes('localhost') || window.location.href.includes("qa")) {
        console.log(data);
    }
}

const shareFacebook = () => {
    ga_push("Share_Events", "Social", "Share to Facebook");
    var url = urlToShare + "?utm_source=z.ynet.co.il&utm_medium=social&utm_campaign=facebook&utm_term=poalim-digital";
    window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url), "_blank");
}

const shareTwitter = () => {
    ga_push("Share_Events", "Social", "Share to Twitter");
    var url = urlToShare + "?utm_source=z.ynet.co.il&utm_medium=social&utm_campaign=twitter&utm_term=poalim-digital";
    window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(url), "_blank");
}

const openNegishut = () => {
    //ga_push("Accessibility", "Open_Accessibility_Clicked");
    window.document.getElementById('INDmenu-btn').click();
}
export{
    openNegishut,
    shareFacebook,
    shareTwitter,
    ga_push
}